import { useEffect } from "react";
import { UserAccessTable } from "../components/userAccessController/UserAccessTable";
import { useUserController } from "../hooks/useUserController";

export const UserAccessContainer: React.FC = () => {
  const { loadUsers } = useUserController();

  useEffect(() => {
    loadUsers();
  }, []);

  return (
    <div className="foc-content flex flex-col overflow-hidden">
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden bg-slate-50/40 p-5">
        <div className="min-h-0 flex-1 overflow-hidden">
          <UserAccessTable />
        </div>
      </main>
    </div>
  );
};
